import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RealEstateAgentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"real_estate_agent"}/>
}
